import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import App from './App'
import './styles/index.css'
import './styles/imed-professional.css'
import './styles/mingming-workspace.css'
import './styles/mingming-results.css'
import './styles/pdf-reader.css'
import './styles/uworld-library.css'
import './styles/imed-app-polish.css'
import './styles/imed-catalog-polish.css'
import './styles/imed-pages-polish.css'
import './styles/responsive-reading.css'
import './styles/loading.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </StrictMode>,
)
